export default function() {
  if (process.client) {
    window.location.replace(`${process.env.galaswapLinkUrl}/referrals`);
  }
}
